import React, { useEffect, useState } from 'react'
import Budget from './Budget'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'
import useModalData from '../../../elements/Hooks/useModalData'
import { checkForm, normalizeDateTimeToDate } from '../../../modules/Utils'
import useFetchObject from '../../../elements/Hooks/useFetchObject'
import Budgets, { Lines as LinesApi } from '../../../api/Budgets'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import useModalShow from '../../../elements/Hooks/useModalShow'
import useSubmit from '../../../elements/Hooks/useSubmit'
import { isEmpty, get, pick } from 'lodash'
import { message } from 'antd'
import useFetchList from '../../../elements/Hooks/useFetchList'
import DocumentsApi from '../../../api/Documents'

export const BUDGET_TYPE_INTERNAL = 'Internal'
export const BUDGET_TYPE_SALES = 'Sales'
const budgetApi = new Budgets()
const formRef = React.createRef()
const formExistingRef = React.createRef()
const docsApi = new DocumentsApi()

function BudgetCont(props) {
  const { owner, hideOptions, oldBudget, showList, onCancel, option } = props
  //console.log({ owner })
  const [submitting, submitValues] = useSubmit(budgetApi.create)
  const [submittingWithAutoLines, submitValuesWithAutoLine] = useSubmit(
    budgetApi.createValuesWithAutoLine
  )
  const [submittingExisting, submitExistingValues] = useSubmit(budgetApi.existing)
  const [submittingOperation, submitOperation] = useSubmit(budgetApi.operation)
  const [updating, updateValues] = useSubmit(budgetApi.update)
  const [removing, removeValues] = useSubmit(budgetApi.remove)
  const {
    object: budget,
    fetching: fetchingBudget,
    fetch: fetchBudgetHook,
    setObject: setBudget,
  } = useFetchObject(() => budgetApi.current(oldBudget._id || owner._id), true, [owner._id])
  const { list, fetching, fetch: fetchLines } = useFetchList(
    LinesApi.list.bind(this, budget._key),
    [budget._rev],
    isEmpty(budget._key)
  )
  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('budgets', budget.status),
    [budget.status, isEmpty(budget.status)]
  )
  const { list: reqs, fetching: fetchingReqs, fetch: fetchReqs } = useFetchList(
    () => budgetApi.reqs(budget._key),
    [budget._key, isEmpty(budget._key)]
  )
  let type = 'new'
  if (!isEmpty(budget)) {
    type = 'edit'
    //fetchBudget()
  }

  const { visible: visibleAdd, onShow: onShowAdd, onCancel: onCancelAdd } = useModalShow()
  const {
    visible: visibleExisting,
    onShow: onShowExisting,
    onCancel: onCancelExisting,
  } = useModalShow()

  async function submit() {
    if (showList) {
      const values = await checkForm(formRef)
      values.period = {
        start: normalizeDateTimeToDate(values, 'period.0', true),
        end: normalizeDateTimeToDate(values, 'period.1', true),
      }
      values.budgetType = option
      const submittedBudget = await submitValues(
        values,
        get(values, 'sales._id') || get(values, 'contract._id')
      )
      if (submittedBudget) {
        onCancel(true)
      }
    } else {
      const submittedBudget = await submitValues(
        { ...pick(owner, ['title', 'currency']) },
        owner._id
      )
      if (submittedBudget) {
        fetchBudget()
      }
    }
  }

  async function submitWithAutoLines() {
    if (showList) {
      const values = await checkForm(formRef)
      values.period = {
        start: normalizeDateTimeToDate(values, 'period.0', true),
        end: normalizeDateTimeToDate(values, 'period.1', true),
      }
      values.budgetType = option
      const submittedBudget = await submitValuesWithAutoLine(values, owner._id)
      if (submittedBudget) {
        onCancel(true)
      }
    } else {
      const submittedBudget = await submitValuesWithAutoLine(
        { ...pick(owner, ['title', 'currency']) },
        owner._id
      )
      if (submittedBudget) {
        fetchBudget()
      }
    }
  }

  async function submitExisting() {
    const values = await checkForm(formExistingRef)
    const submittedBudget = await submitExistingValues(values, owner._id)
    if (submittedBudget) {
      onCancelExisting()
      fetchBudget()
    }
  }

  async function update() {
    const values = await checkForm(formRef)
    values.period = {
      start: normalizeDateTimeToDate(values, 'period.0', true),
      end: normalizeDateTimeToDate(values, 'period.1', true),
    }
    values.budgetType = option
    const updated = await updateValues({
      ...pick(budget, ['_id', '_key', '_rev']),
      ...values,
    })
    if (!isEmpty(updated)) setBudget(updated)
  }

  async function remove() {
    const removed = await removeValues({
      ...pick(budget, ['_id', '_key', '_rev']),
    })
    removed && onCancel(true)
    // await fetchBudget()
  }

  const linesModal = useModalData(LinesApi.create, LinesApi.update, LinesApi.remove, fetchLines)

  async function submitLine() {
    const newObject = await linesModal.checkForm()
    linesModal.setSubmitting(true)
    try {
      await LinesApi.create({ ...newObject, budget })
      linesModal.onCancel()
      fetchLines()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    linesModal.setSubmitting(false)
  }

  linesModal.submit = submitLine
  linesModal.fetching = fetching
  linesModal.fetch = fetchLines

  async function fetchBudget() {
    await fetchBudgetHook()
    await fetchLines()
  }

  const isUpdatable =
    actions.find((a) => a.key === 'update' || a.key === 'remove') || type === 'new'

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    switch (operation) {
      default:
        const budgetDB = await submitOperation(operation, {
          ...pick(budget, ['_key', '_rev', '_id']),
          owner: owner._id,
        })
        fetchBudget()
        if (budgetDB) setBudget(budgetDB)
        break
    }
    hide()
  }

  return (
    <Budget
      {...{
        type,
        option,
        list,
        linesModal,
        budget,
        updating,
        update,
        fetchingBudget,
        fetchBudget,
        visibleAdd,
        onShowAdd,
        onCancelAdd,
        submitting,
        submit,
        formRef,
        handleActions,
        visibleExisting,
        onShowExisting,
        onCancelExisting,
        submittingExisting,
        submitWithAutoLines,
        owner,
        removing,
        remove,
        actions,
        fetchingActions,
        fetchActions,
        formExistingRef,
        submitExisting,
        isUpdatable,
        hideOptions,
        showList,
        reqs,
        fetchingReqs,
        fetchReqs,
      }}
    />
  )
}

BudgetCont.propTypes = {}
BudgetCont.defaultProps = {
  hideOptions: {
    existing: false,
  },
  option: BUDGET_TYPE_SALES,
  owner: {},
  oldBudget: {},
  showList: false,
}

export default compose(withLoadingSection, withRouter)(BudgetCont)
